export default "__VITE_ASSET__BuDCmDgE__"